import { mapGetters, mapMutations, mapActions } from 'vuex'
import Loading from '@/components/loading/index.vue'
import ClientType from '@/helper/ClientType'

export default {
  components: {
    Loading
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dialog: false,
      idUserType: '',
      isLoading: false,
      clientType: ClientType,
      typeClient: [
        {
          name: 'Pré Pago',
          id: 'pre'
        },
        {
          name: 'Pós Controle',
          id: 'pos_controle'
        },
        {
          name: 'Pós Pago',
          id: 'pos_pago'
        }
      ]
    }
  },
  mounted () {
    this.setClientInfo()

    this.getUpdateClientData()
  },
  beforeDestroy () {
    this.CLEAR_CLIENT_FILES_STORE()
    this.SET_SELECTED_CLIENT()
  },
  computed: {
    ...mapGetters([
      'getterSelectedClient'
    ])
  },
  methods: {
    ...mapActions([
      'actionGetUpdateClientData'
    ]),
    ...mapMutations([
      'CLEAR_CLIENT_FILES_STORE',
      'SET_SELECTED_CLIENT'
    ]),
    setClientInfo () {
      this.dialog = true

      this.idUserType = this.getterSelectedClient.type
    },
    getUpdateClientData () {
      this.isLoading = true

      this.actionGetUpdateClientData(this.getterSelectedClient)
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar os dados, tente novamente mais tarde',
            type: 'danger'
          })
        })
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
